export const TEST_ID = 'windDirectionControl';

export const LABEL = 'Wind Direction';

export const WIND_OPTIONS = [
    { label: 'No wind', value: 'NONE' },
    { label: 'Set wind', value: 'SET' }
];

export const WIND_NONE_VALUE = 'NONE';

export const WIND_SET_VALUE = 'SET';

export const WIND_NONE_INDEX = 0;

export const WIND_SET_INDEX = 1;

export const WIND_MIN = 0;

export const WIND_MAX = 359.9;

export const WIND_STEP = 1;

export const WIND_UNIT = 'deg';

export const WIND_DEFAULT = 0;
